<div class="item-card" [class.collapsed]="collapsed">
    <div class="row" *ngIf="!edit">
        <div *ngIf="selectTable" class="col-1">
            <p-checkbox *ngIf="typeSelect === 'simple'" [(ngModel)]="checked" (onChange)="selectSimpleClick($event)"
                binary="true"></p-checkbox>
            <p-checkbox *ngIf="typeSelect === 'multiple'" [(ngModel)]="checked" (onChange)="selectMultipleClick($event)"
                binary="true"></p-checkbox>
        </div>
        <div *ngFor="let column of columns" [ngClass]="column.class ? column.class : 'col'"
            class="align-items-center d-flex">
            <mapfre-auditlib-circle *ngIf="column.type === 'name'" [name]="getName(data[column.field])"
                [title]="getName(data[column.field])">
            </mapfre-auditlib-circle>
            <mapfre-auditlib-circle *ngIf="column.type === 'profile'" [name]="data[column.field]"
                [img]="data[column.field2]" [title]="column.options.title">
            </mapfre-auditlib-circle>
            <img *ngIf="column.type === 'img'" class="img-fluid w-100"
                [src]="column.options.url ? column.options.url : data[column.field]" />
            <img *ngIf="column.type === 'flag'" class="img-fluid" width="60%"
                [src]="getFlag(data[column.field],column.options.field)" />
            <div *ngIf="column.type === 'boolean'" class="state"
                [ngClass]="data[column.field] ? 'state-active':'state-inactive'">
                <div class="align-items-center d-flex">
                    <i class="icon icon-24-px-tick-doble"></i>
                    {{column.options.text}}
                </div>
            </div>
            <div *ngIf="column.type === 'date'">
                {{getDate(data[column.field]) | dateFormat:false:false | async }}
            </div>
            <div class="word-break" *ngIf="column.type === 'input' && data[column.field]"
                [innerHTML]="data[column.field]" pTooltip="{{ data[column.field] }}" tooltipPosition="bottom">
            </div>
            <div *ngIf="column.type === 'input' && !data[column.field]" [innerHTML]="'-'">
            </div>
            <div class="word-break" *ngIf="column.type === 'number' && data[column.field]"
                [innerHTML]="data[column.field]">
            </div>
            <div *ngIf="column.type === 'number' && !data[column.field]" [innerHTML]="0">
            </div>
            <div translate *ngIf="column.type === 'select' && column.options.selectionMode === 'simple'"
                [innerHTML]="get(data[column.field],column.options.field)">
            </div>
            <div *ngIf="column.type === 'select' && column.options.selectionMode === 'multiple'">
                <div *ngIf="data[column.field]">
                    <div *ngIf="data[column.field].length <= 2">
                        <div *ngFor="let item of data[column.field]" [innerHTML]="get(item, column.options.field)">
                        </div>
                    </div>
                    <div *ngIf="data[column.field].length > 2" [escape]=false
                        [pTooltip]="showList(data[column.field], column.options.field)">
                        <div *ngFor=" let item of data[column.field].slice(0,2)"
                            [innerHTML]="get(item, column.options.field)">
                        </div>
                        <div>...</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="align-items-center d-flex" [ngClass]="defaultActions.class ? defaultActions.class : 'col-2'"
            *ngIf="actions?.length || defaultActions?.delete || defaultActions?.edit">
            <button class="no-styles" (click)="toggleEdit()" *ngIf="defaultActions?.edit !== false">
                <i class="icon icon-24-px-editar"></i>
            </button>
            <button (click)="onDelete()" class="no-styles" *ngIf="defaultActions?.delete !== false">
                <i class="icon icon-24-px-eliminar"></i>
            </button>
            <button class="no-styles" (click)="onActionClicked(action)" *ngFor="let action of actions">
                <i class="icon" [ngClass]="action.icon"></i>
            </button>
        </div>
    </div>

    <mapfre-auditlib-item-form *ngIf="edit" [nuuma]="nuuma" [form]="form" (updated)="onSave()"
        (selectChange)="onSelectChange($event)" [defaultActions]="defaultActions" (cancelled)="onCancelled()"
        [columns]="columns">
    </mapfre-auditlib-item-form>

</div>